(function () {
  var header = document.getElementById('pageheader');
  if (!header || !header.classList.contains('pageheader--sticky')) return;

  var threshold = 60;
  var ticking = false;

  function update() {
    header.classList.toggle('is-gk2-shrunk', window.scrollY > threshold);
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  update();
})();
